var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 22,
    viewBox: "0 0 512 512",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m385.621 390.771c39.335-35.996 61.739-86.636 61.739-140.162 0-104.766-85.233-190-190-190s-190 85.234-190 190c0 125.188 119.958 217.084 241.508 182.919 95.322 21.903 90.336 21.081 92.492 21.081 7.419 0 12.269-7.822 8.944-14.473zm-77.032 22.429c-.958 0-1.915.138-2.842.412-109.47 32.448-218.387-50.188-218.387-163.004 0-93.738 76.262-170 170-170s170 76.262 170 170c0 50.256-22.078 97.672-60.573 130.089-3.535 2.978-4.569 7.988-2.503 12.122l18.637 37.271c-75.846-17.41-72.19-16.89-74.332-16.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.4b087dddbf67c3bca4cbf3bb1297d871.svg";
export { ForwardRef as ReactComponent };